import { render } from "./Infoperso.vue?vue&type=template&id=9502ebf4&scoped=true"
import script from "./Infoperso.vue?vue&type=script&lang=js"
export * from "./Infoperso.vue?vue&type=script&lang=js"

import "./Infoperso.vue?vue&type=style&index=0&id=9502ebf4&scoped=true&lang=css"
import "./Infoperso.vue?vue&type=style&index=1&id=9502ebf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9502ebf4"]])

export default __exports__